import type { CheckpointQuestion } from '@/utils/checkpoint.utils'
import type { QuestionAnswer } from './checkpoint-question.utils'
import {
  GroupHeader,
  ImagesQuestion,
  MultiChoiceQuestion,
  SelectChoiceQuestion,
  SingleChoiceQuestion,
  TextAreaQuestion,
} from './checkpoint-question-fields'
import { type CheckpointSparePart, SparePartsQuestion } from './spare-parts-question'

type Props = {
  question: CheckpointQuestion
  answer: QuestionAnswer
  onChange(answer: QuestionAnswer): void
  /** The work order's parts and workshop — only read by `spare-parts` questions. */
  spareParts?: CheckpointSparePart[]
  workshopId?: string
}

export const CheckpointQuestionField = ({
  question,
  answer,
  onChange,
  spareParts,
  workshopId,
}: Props) => {
  switch (question.type) {
    case 'group':
      return <GroupHeader text={question.text} />
    case 'text-area':
      return <TextAreaQuestion question={question} answer={answer} onChange={onChange} />
    case 'images':
      return <ImagesQuestion question={question} answer={answer} onChange={onChange} />
    case 'select-choice':
      return <SelectChoiceQuestion question={question} answer={answer} onChange={onChange} />
    case 'multi-choice':
      return <MultiChoiceQuestion question={question} answer={answer} onChange={onChange} />
    case 'spare-parts':
      return (
        <SparePartsQuestion
          question={question}
          answer={answer}
          onChange={onChange}
          spareParts={spareParts ?? []}
          workshopId={workshopId ?? ''}
        />
      )
    default:
      return <SingleChoiceQuestion question={question} answer={answer} onChange={onChange} />
  }
}
